<template>
    <div class="dashboard-root">
    <BlockedDashboard v-if="isDashboardBlocked"/>
    <div
            v-else
            class="dashboard"
            :class="currentBoardClass"
            @mouseover="catchFeaturesEvent"
    >
        <div
                class="dashboard-settings-line"
                :class="{collapsed:!isShowTopPanel}"
                v-if="currentBoard.projects"
        >
            <VHeader>
                <template #left>
                    <div>
                        <div
                                v-if="!isEditMode"
                                class="dashboard__import-board"
                                @click="importBoard"
                                @mouseover="showTooltip($event,'importBoard')"
                        >
                            <span class="dashboard__import-board-icon"></span>
                        </div>
                    </div>
                    <BoardMenu
                            :boards.sync="boards"
                            :is-menu-collapsed="isMenuCollapsed"
                            :activeBoardIndex.sync="activeBoardIndex"
                            :is-edit-mode="isEditMode"
                            :is-disabled="currentBoard.tempData.isEditingSettingsDisabled"
                            @addBoard="addBoard(null)"
                            @deleteBoard="deleteBoard"
                            @updateStateForBoards="updateStateForBoards('boardmenu')"
                            @updateActiveBoardIndexAfterSwap="updateActiveBoardIndexAfterSwap"
                            @showTooltip="showTooltip"
                            @changeActiveTab="changeActiveTab"
                    >
                    </BoardMenu>
                </template>
                <!--                <template #right>-->
                <!--                    <HeaderViews-->
                <!--                        :active-view-name="currentBoard.featuresViewName"-->
                <!--                        @changeFeaturesView="changeFeaturesView"-->
                <!--                    ></HeaderViews>-->
                <!--                </template>-->
            </VHeader>
            <TopMenu
                    :current-board="currentBoard"
                    :is-show-top-panel.sync="isShowTopPanel"
                    :is-editing-settings-disabled="currentBoard.tempData.isEditingSettingsDisabled"
                    :all-projects="allProjects"
                    :all-events="allEvents"
                    :all-features="allFeatures"
                    :boards="boards"
                    :active-board-index="activeBoardIndex"
                    :saved-data="currentBoard.savedData"
                    :is-edit-mode="isEditMode"
                    :presets="presets"
                    :feature-filters-id="featureFiltersId"
                    :is-features-updating="currentBoard.tempData.isFeaturesUpdating"
                    :all-events-and-all-formulas="currentBoard.allEventsAndAllFormulas"
                    :features-settings="currentBoard.featuresSettings || {}"
                    dashboard-type="source"
                    ref="topmenu"
                    @updateDashboardData="updateDashboardData"
                    @showTooltip="showTooltip"
                    @updateHiddenColumnsStyles="updateHiddenColumnsStyles"
                    @updateColumnsColorStyles="updateColumnsColorStyles"
                    @updateFeatureFiltersId="updateFeatureFiltersId"
                    @applyFeatureFilter="applyFeatureFilter"
                    @applyFilterSummaryTable="applyFilterSummaryTable"
                    @swapHeaderInFeatures="swapHeaderInFeatures"
                    @rerenderFeatures="rerenderFeatures"
                    @rerenderFeaturesAfterSwap="rerenderFeaturesAfterSwap"
                    @addColumnWidthForNewFormula="addColumnWidthForNewFormula"
                    @deleteColumnWidthForNewFormula="deleteColumnWidthForNewFormula"
                    @updateColumnWidthForFormula="updateColumnWidthForFormula"
                    @updateStateForBoards="updateStateForBoards"
            ></TopMenu>
        </div>
        <Subscriptions
                :subscriptions="currentBoard.subscriptions"
                :current-board="currentBoard"
                :is-data-updating="areSubscriptionsUpdating"
                :are-additional-subscriptions-loading="currentBoard.tempData.areAdditionalSubscriptionsLoading"
                :cohort="currentBoard.cohort"
                :features="currentBoard.featuresData"
                @showTooltip="showTooltip"
                @openSubscriptionPopup="openSubscriptionPopup"
                @updateBoardProperty="updateBoardProperty"
        ></Subscriptions>
        <div
                class="page-body"
                v-if="currentBoard && currentBoard.featuresData && currentBoard.featuresData.length"
        >
            <FeaturesBlock
                    :features="currentBoard.features"
                    :features-data="currentBoard.featuresData"
                    :events="currentBoard.events"
                    :current-precision="currentBoard.precision"
                    :board-styles="currentBoard.styles"
                    :precisions="precisions"
                    :formulas="currentBoard.formulas"
                    :features-settings="currentBoard.featuresSettings || {}"
                    :is-features-updating="currentBoard.tempData.isFeaturesUpdating"
                    :is-summary-table-updating="currentBoard.tempData.isSummaryTableUpdating"
                    :deleted-events-and-formulas-indexes="currentBoard.deletedEventsAndFormulasIndexes"
                    :all-events-and-all-formulas="currentBoard.allEventsAndAllFormulas"
                    :all-events="currentBoard.allEvents"
                    :all-formulas="currentBoard.allFormulas"
                    :projects="currentBoard.projects"
                    :is-menu-collapsed="isMenuCollapsed"
                    :is-edit-mode="isEditMode"
                    :current-board-class="currentBoardClass"
                    :current-board="currentBoard"
                    ref="featureBlock"
                    @closeFeature="closeFeature"
                    @applyFilter="applyFeatureFilter"
                    @applyFilterSummaryTable="applyFilterSummaryTable"
                    @showTooltip="showTooltip"
                    @updateFeaturesSettings="updateFeaturesSettings"
                    @updateCurrentPrecision="updateCurrentPrecision"
                    @updateSummaryCohort="updateSummaryCohort"
                    @updateFeatureFiltersId="updateFeatureFiltersId"
                    @updateFeaturesOrder="updateFeaturesOrder"
                    @saveDashboardDebouncedLong="callSaveDashboardDebouncedLong"
                    @saveDashboard="saveDashboard"
                    @updateStateForBoards="updateStateForBoards"
                    @addGeoData="addGeoData"
            ></FeaturesBlock>
        </div>
        <div id="preloadedImages">
            <img
                    data-v-aaa7d61e=""
                    src="/icons/pages/dashboard/formulas/icon_delete.svg"
                    alt="Settings"
            >
            <img
                    data-v-76f57b15=""
                    src="/icons/components/VFeatureBlock/icon_add-sum.svg"
                    alt="Settings"
            >
        </div>
    </div>
    </div>
</template>

<script>
    import FeaturesBlock from './Dashboard/FeaturesBlock';
    import TopMenu from './Dashboard/TopMenu';
    import apiFeatures from '@/api/apiFeatures';
    import apiBoards from '@/api/apiBoards';
    import apiEvents from '@/api/apiEvents';
    import BoardMenu from './Dashboard/BoardMenu';

    import {getUrlParam, setUrlParam, deleteUrlParam} from '@/helpers/urlHelper';
    import {isIncludesAll, areArraysEqual, areObjectsEqual} from '@/helpers/dataHelper';
    import {
        mapFeatureData,
        mapSummaryTable,
        getIndexesByNames,
    } from './Dashboard/mapping.js';
    import {
        getEventsWithData,
        getFeaturesWithData,
        getProjectsWithData,
        getDefaultFeatureWithDataByName,
        getPrecisions, getBoardsetIndexById, getBoards, setBoards, getEvents,
        isTestBoardsMode,
        getUser,
    } from '@/api/apiServices';
    import BlockedDashboard from './Dashboard/BlockedDashboard';
    import {
        getDataTimeRangePresets,
        setDataTimePresets,
        getObjectFromArray,
    } from '@/helpers/dateTimeHelper';
    import {
        getDashboardTooltip,
    } from '@/pages/Dashboard/tooltips';
    import {initPreload} from '@/api/apiServices';
    import attributeGroups from './Dashboard/attributeGroups.json';
    import {createCssRules, deleteCssRules} from '../helpers/domHelper';
    import {addTempBoardData, assignGlobalMethods, generateRandomString} from '../helpers/dataHelper';
    import apiHelpers from '../api/apiHelpers';
    import {eventBus} from '../main';
    import {getSourceGroups} from '../api/apiServices';
    import Subscriptions from './Dashboard/Subscriptions';
    import {updateTimeHistory} from '../helpers/dateTimeHelper';
    import {getSavedDashboardData} from '../helpers/testData';
    import {getSinceRange} from '@/helpers/dateTimeHelper';

    export default {
        name: 'Dashboard',
        components: {
            FeaturesBlock,
            BoardMenu,
            TopMenu,
            Subscriptions,
            BlockedDashboard,
        },
        props: {
            isMenuCollapsed: {
                type: Boolean,
                required: true,
            },
            isEditMode: {
                type: Boolean,
                required: true,
            },
        },
        data() {
            return {
                attributeGroups,
                isShowTopPanel: true,
                presets: [],
                activeBoardIndex: +getBoardsetIndexById(getUrlParam('board_id')) >= 0 ? +getBoardsetIndexById(getUrlParam('board_id')) : 0,
                boards: [],
                newFormula: {
                    name: '',
                    equation: '',
                },
                currentBoard: {},
                allProjects: Object.freeze(getProjectsWithData()),
                allEvents: Object.freeze(getEventsWithData()),
                allFeatures: getFeaturesWithData(),
                precisions: Object.freeze(getPrecisions()),
                featureFiltersId: null,
                geoRows: [],
                scrollPositions: {
                },
            };
        },
        created() {
            if (this.isDashboardBlocked) {
                return;
            }
            if (sessionStorage.getItem('activeBoardIndex')) {
                this.activeBoardIndex = +sessionStorage.getItem('activeBoardIndex');
            }
            this.initClearData();
            this.initBoards();
            eventBus.$on('DashboardInitBoards', this.initBoards);
            this.createEventListeners();
        },
        mounted() {
            if (this.isDashboardBlocked) {
                return;
            }
            assignGlobalMethods(this.rerenderFeaturesVirtualTable);
        },
        beforeDestroy() {
            if (this.isDashboardBlocked) {
                return;
            }
            sessionStorage.setItem('activeBoardIndex', this.activeBoardIndex);
            this.removeEventListeners();
        },
        computed: {
            isDashboardBlocked() {
                return !!(getUser() || {}).block_dashboards;
            },
            areSubscriptionsUpdating() {
                return this.currentBoard.tempData.areSubscriptionsUpdating
                    || this.currentBoard.tempData.arePredictionsUpdating
                    || this.currentBoard.tempData.isFeaturesUpdating
                    || this.currentBoard.tempData.areHistoryActivationsUpdating
                    || this.currentBoard.tempData.isHistoryUpdating;
            },
            updateDashboardDataDebounced() {
                return this.updateDashboardDataDebouncedFabric()(750);
            },
            saveDashboardDebouncedLong() {
                return this.saveDashboardFabric()(5000, true);
            },
            currentBoardClass() {
                return `Board-${this.currentBoard.uniqueId}`;
            },
        },
        watch: {
            activeBoardIndex: {
                immediate: false,
                handler() {
                    // this.stopPreviousBoardRequests(newIndex);
                    this.getCurrentBoards();
                    this.normalizeView();

                    this.$nextTick(() => {
                      window.scrollTo({ top: this.scrollPositions[this.currentBoard.id] || 0, behavior: 'instant' });
                    });
                },
            },
            'currentBoard.formulas': {
                immediate: false,
                deep: true,
                handler() {
                    this.boards[this.activeBoardIndex].allEventsAndAllFormulas =
                        [...this.boards[this.activeBoardIndex].allEvents, ...this.boards[this.activeBoardIndex].allFormulas];
                },
            },
        },
        methods: {
            async addGeoData(oldGeoRow) {
              if(!this.geoRows.map(({value})=>value).includes(oldGeoRow.value)){
                this.geoRows.push(oldGeoRow);
              }
              const boardIndexForRequest = this.activeBoardIndex;
              const additionalFilters = this.mapFilters();
              const savedBoard = _.cloneDeep(this.boards[boardIndexForRequest]);
              // const rows = await this.getGeoHistory(savedBoard, boardIndexForRequest, additionalFilters,oldGeoRow.value);
              const boardWithSavedBoardId = this.boards[boardIndexForRequest];
              const geoFeatureIndex = boardWithSavedBoardId.featuresData.findIndex((featureData) =>
                  featureData.name === 'geo');
              const oldGeoData = _.cloneDeep(boardWithSavedBoardId.featuresData[geoFeatureIndex]);
              const geoRowIndex = oldGeoData.rows.findIndex((row)=> row.uniqueId === oldGeoRow.uniqueId);
              this.getGeoHistory(savedBoard, boardIndexForRequest, additionalFilters,oldGeoRow.value).then((rows)=>{
                oldGeoData.rows[geoRowIndex].subrows = rows;
                oldGeoData.rows[geoRowIndex].areSubrowsLoaded = true;
                oldGeoData.rows[geoRowIndex].areSubrowsLoading = false;
                oldGeoData.rows[geoRowIndex].areSubrowsOpen = true;
                boardWithSavedBoardId.featuresData.splice(geoFeatureIndex, 1, oldGeoData);
              }).catch(e=>{
                oldGeoData.rows[geoRowIndex].areSubrowsLoaded = false;
                oldGeoData.rows[geoRowIndex].areSubrowsLoading = false;
                oldGeoData.rows[geoRowIndex].areSubrowsOpen = false;
                boardWithSavedBoardId.featuresData.splice(geoFeatureIndex, 1, oldGeoData);
                console.log(e)
              })

            },
            updateDashboardDataDebouncedFabric() {
                const self = this;
                return function (delay = 750, isForce = false) {
                    return _.debounce(function () {
                        self.updateDashboardData('debounced', isForce);
                    }, delay);
                };
            },
            saveDashboard() {
                this.updateStateForBoards('updateDashboardData', true, true);
            },
            saveDashboardFabric() {
                const self = this;
                return function (delay = 750) {
                    return _.debounce(function () {
                        self.updateStateForBoards('updateDashboardData', true, true);
                    }, delay);
                };
            },
            callSaveDashboardDebouncedLong() {
                this.saveDashboardDebouncedLong();
            },
            pageLoaded() {
                if (!areArraysEqual(this.allProjects, getProjectsWithData())) {
                    this.allProjects = Object.freeze(getProjectsWithData());
                    this.updateDashboardData('pageLoaded', true, true);
                }

            },
            initBoards() {
                this.boards = getBoards();
                if (this.activeBoardIndex >= this.boards.length) {
                    this.activeBoardIndex = 0;
                }
                if (this.boards.length) {
                    this.getCurrentBoards();
                } else {
                    this.initDefaultData();
                }
            },
            createEventListeners() {
                window.addEventListener('scroll', this.changeShadowVisibility, false);
            },
            removeEventListeners() {
                window.removeEventListener('scroll', this.changeShadowVisibility, false);
            },
            initClearData() {
                this.savedBoards = {};
                this.deletedFormulasIndex = 0;
            },
            getSavedDataFeatureSettings() {
                const sessionFeaturesSettings = {};
                this.currentBoard.featuresData.forEach((feature) => {
                    sessionFeaturesSettings[feature.name] = {
                        filterValue: feature.filterValue,
                    };
                });
                this.currentBoard.savedData.sessionFeaturesSettings = Object.freeze(sessionFeaturesSettings);
            },
            catchFeaturesEvent(event) {
                if (this.currentBoard.tempData.isDashboardLoaded && this.$refs.featureBlock) {
                    this.$refs.featureBlock.catchFeaturesEvent(event, true);
                }
            },
            catchAttributesEvent(event, isAdd) {
                const optionText = event.target.querySelector('.VFilter-dropdown-row__option').innerHTML.toLowerCase().trim();
                const highlightElement = document.querySelector(`.VFeatureBlock-${optionText}`);
                if (highlightElement) {
                    if (isAdd) {
                        highlightElement.classList.add('VFeatureBlock_highlight');
                    } else {
                        highlightElement.classList.remove('VFeatureBlock_highlight');
                    }
                }
            },
            clickAttributesRow(option) {
                const yOffset = document.querySelector('.dashboard-settings-line').clientHeight + 75;
                const element = document.querySelector(`.VFeatureBlock-${option.name}`);
                if (element) {
                    const y = element.getBoundingClientRect().top + window.pageYOffset - yOffset;
                    window.scrollTo({top: y, behavior: 'smooth'});
                }
            },
            updateColumnsColorStyles() {
                deleteCssRules.call(this, this.currentBoard.styles.columnsColorStyles);
                this.currentBoard.styles.columnsColorStyles = createCssRules.call(this, () => {
                    return this.currentBoard.allEvents.map((event, colorIndex) => {
                        const styles = ` {color: ${event.color};font-weight:${event.fontWeight}`;
                        return `.${this.currentBoardClass} .VFeatureBlock-data-column:nth-of-type(${colorIndex + 2}) ${styles}`;
                    });
                });
            },
            updateHiddenColumnsStyles(deletedIndexes) {
                deleteCssRules.call(this, this.currentBoard.styles.hiddenColumnsStyles);
                this.currentBoard.styles.hiddenColumnsStyles = createCssRules.call(this, () => {
                    return deletedIndexes.map((index) => {
                        return `.${this.currentBoardClass} .VFeatureBlock-data-column:nth-of-type(${index + 2}) {display: none;}`;
                    });
                });
            },
            changeShadowVisibility() {
                const element = document.querySelector('.dashboard-settings-line');
                if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0 && element) {
                    document.querySelector('.dashboard-settings-line').classList.add('dashboard-settings-line_sticked');
                } else if (element) {
                    document.querySelector('.dashboard-settings-line').classList.remove('dashboard-settings-line_sticked');
                }
            },
            updateBoardProperty(propertyName, value) {
                this.boards[this.activeBoardIndex][propertyName] = value;
                this.updateStateForBoards(`update${propertyName}`);
                // const equal = this.mapFilters();
                // this.setHeightsForFeaturesLoadings();
                // this.getEvents(equal);
            },
            updateCurrentPrecision(newPrecision) {
                this.boards[this.activeBoardIndex].precision = newPrecision;
                this.updateStateForBoards('updateCurrentPrecision');
                const additionalFilters = this.mapFilters();
                this.setHeightsForFeaturesLoadings();
                const savedBoard = _.cloneDeep(this.boards[this.activeBoardIndex]);
                this.getEvents(_.cloneDeep(savedBoard),this.activeBoardIndex, additionalFilters, true);
            },
            updateSummaryCohort(newGroupByCohort) {
                this.boards[this.activeBoardIndex].groupByCohort = newGroupByCohort;
                this.updateStateForBoards('updateSummaryCohort');
                const additionalFilters = this.mapFilters();
                this.setHeightsForFeaturesLoadings();
                const savedBoard = _.cloneDeep(this.boards[this.activeBoardIndex]);
                this.getEvents(_.cloneDeep(savedBoard),this.activeBoardIndex, additionalFilters,true, false);
            },
            updateFeaturesOrder() {
                const newFeatureOrder = this.boards[this.activeBoardIndex].featuresData.map((feature) => feature.name);
                this.boards[this.activeBoardIndex].featuresOrder = this.boards[this.activeBoardIndex].featuresOrder || [];
                if (!areArraysEqual(newFeatureOrder, this.boards[this.activeBoardIndex].featuresOrder)) {
                    this.boards[this.activeBoardIndex].featuresOrder
                        = newFeatureOrder;
                    this.updateStateForBoards('updateFeaturesOrder');
                }
            },
            updateFeatureFiltersId(newFeatureFilterId) {
                this.featureFiltersId = newFeatureFilterId;
            },
            normalizeView() {
                this.$nextTick(() => {
                    this.$refs.featureBlock.$refs.vfeatureblock.forEach((feature) => {
                        if (feature.$refs.virtualtable) {
                            feature.calcWidthForColumns();
                            feature.updateColumnVisibilityStyles();
                            feature.$refs.virtualtable.updateScrollableClass();
                        }
                    });
                });
            },
            getCurrentBoards() {
                this.currentBoard = this.boards[this.activeBoardIndex];
                const eventsNames = this.currentBoard.events.map((e) => e.name);
                const featuresNames = this.currentBoard.features.map((e) => e.name);
                this.currentBoard.savedData.events = Object.freeze(eventsNames);
                this.currentBoard.savedData.features = Object.freeze(featuresNames);
                if (!this.currentBoard.isFirstTimeLoaded) {
                    this.currentBoard.tempData.isDashboardLoaded = false;
                    this.updateDashboardData('getCurrentBoards', true, false);
                } else {
                    this.currentBoard.tempData.isDashboardLoaded = true;
                }
                if (this.isEditMode) {
                    setUrlParam.call(this, 'board_id', this.currentBoard.id);
                }
            },
            saveStateForBoard(previousActiveIndex) {
                if (this.boards[previousActiveIndex]) {
                    this.boards[previousActiveIndex].featuresData.forEach((featureData, featureDataIndex) => {
                        featureData.assignedItems =
                            this.$refs.featureBlock.$refs.vfeatureblock[featureDataIndex].datatableItems;
                        featureData.areItemsCached = true;
                    });
                }
            },
            initDefaultData() {
                const defaultEventsNames = ['click', 'land', 'expense', 'install', 'active_trials', 'paying_users'];
                const defaultEvents = getEventsWithData().filter((event) => defaultEventsNames.includes(event.name));
                const defaultFeaturesNames = ['source', 'campaign', 'adset'];
                const defaultFeatures = this.allFeatures.filter((feature) =>
                    defaultFeaturesNames.includes(feature.name));
                const projects = _.cloneDeep(getProjectsWithData());
                const defaultProjects = projects.length ? [getProjectsWithData()[0]] : [];
                const defaultBoard = {
                    name: 'Default Board',
                    features: defaultFeatures,
                    events: defaultEvents,
                    filters: [],
                    allEventsAndAllFormulas: [],
                    projects: defaultProjects,
                    datePeriod: {start: this.$moment(), end: this.$moment(), preset: '7 days', utc: false},
                    cohort: true,
                    sandbox: false,
                    precision: 'day',
                    formulas: [],
                    featuresData: [],
                    featuresSettings: {},
                    currentSourceName: getSourceGroups()[0].name,
                    id: '',
                    isFirstTimeLoaded: false,
                    styles: {
                        columnVisibilityStyles: '',
                        columnsWidthStyles: '',
                        selectedRowsStyles: '',
                    },
                    groupByCohort: true,
                };
                apiBoards.createBoard(defaultBoard, true).then((resolve) => {
                    const boardId = resolve.data.id;
                    defaultBoard.id = boardId;
                    defaultBoard.uniqueId = boardId;
                    const boards = _.clone(this.boards);
                    boards.push(defaultBoard);
                    setBoards(boards);
                    this.boards = Object.freeze(getBoards());
                    setUrlParam.call(this, 'board_id', boardId);
                    this.getCurrentBoards();
                    this.$emit('updateEditMode');
                }).catch(() => {
                });
            },
            addBoard(callback) {
                this.$refs.featureBlock.$refs.vfeatureblock.forEach((featureElem) => {
                    featureElem.showFeaturesLoadings();
                });
                setTimeout(() => {
                    const newBoard = _.cloneDeep(this.currentBoard);
                    newBoard.featuresData.forEach((featureData) => {
                        featureData.styles = {
                            columnVisibilityStyles: '',
                            columnsWidthStyles: '',
                        };
                    });
                    let newBoardIndex;
                    if (!callback) {
                        newBoard.name = `copy_${newBoard.name}`;
                        newBoard.styles = {
                            columnVisibilityStyles: '',
                            columnsWidthStyles: '',
                            selectedRowsStyles: '',
                        };
                        newBoard.uniqueId = generateRandomString();
                        this.updateBoardByIndex(newBoard, this.boards.length);
                        this.saveStateForBoard(this.activeBoardIndex);
                        newBoardIndex = this.boards.length - 1;
                        this.activeBoardIndex = newBoardIndex;
                        this.currentBoard = this.boards[newBoardIndex];
                        this.updateColumnsColorStyles();
                        this.updateHiddenColumnsStyles(this.currentBoard.deletedEventsAndFormulasIndexes);
                        this.$refs.featureBlock.$refs.vfeatureblock.forEach((featureElem) => {
                            featureElem.setColumnsWidthStyles();
                            featureElem.updateColumnVisibilityStyles();
                        });
                        this.$nextTick(() => {
                            this.$refs.featureBlock.$refs.vfeatureblock.forEach((featureElem) => {
                                featureElem.showFeaturesLoadings(false);
                            });
                        });
                    }
                    apiBoards.createBoard(newBoard, this.isEditMode).then((resolve) => {
                        if (callback) {
                            callback(resolve.data.id);
                        } else {
                            this.boards[newBoardIndex].id = resolve.data.id;
                            this.updateStateForBoards('addBoard', false);
                        }
                    });
                }, 4);
            },
            deleteBoard(tabIndex) {
                if (this.activeBoardIndex === 0) {
                    this.changeActiveTab(1, 0);
                }
                this.$nextTick(() => {
                    const boards = _.clone(this.boards);
                    const deleteBoardId = this.boards[tabIndex].id;
                    boards.splice(tabIndex, 1);
                    this.boards = Object.freeze(boards);
                    this.updateStateForBoards('deleteBoard', false);
                    if (this.activeBoardIndex > 0 && tabIndex <= this.activeBoardIndex) {
                        this.activeBoardIndex -= 1;
                    }
                    if (!this.boards.length) {
                        deleteUrlParam.call(this, 'board_id');
                    }
                    apiBoards.deleteBoardById(deleteBoardId, this.isEditMode).then(() => {
                    }).catch(() => {
                    });
                });

            },
            closeFeature(featureIndex, featureData) {
                const features = _.clone(this.boards[this.activeBoardIndex].features);
                features.splice(featureIndex, 1);
                this.boards[this.activeBoardIndex].features = Object.freeze(features);
                this.updateDashboardDataDebounced();
                this.$refs.topmenu.$refs.filterattributes.clearFeatureAfterDelete(featureData);

            },
            updateDashboardData(methodName, forceUpdate = false, isUpdateCache = true) {
                const featuresNames = this.currentBoard.features.map((e) => e.name);
                const eventsNames = this.currentBoard.events.map((e) => e.name);
                const formattedSavedDates = _.cloneDeep(this.currentBoard.savedData.period);
                const formattedDates = _.cloneDeep(this.currentBoard.datePeriod);
                if (formattedSavedDates.preset === 'Since' && formattedDates.preset === 'Since') {
                    delete formattedSavedDates.end;
                    delete formattedDates.end;
                    formattedSavedDates.start = this.$moment(formattedSavedDates.start).format('YYYY-MM-DD');
                    formattedDates.start = this.$moment(formattedDates.start).format('YYYY-MM-DD');
                }
                const isFeaturesAdded = !isIncludesAll(this.currentBoard.savedData.features, featuresNames);
                const isPeriodChanged = !areObjectsEqual(formattedSavedDates, formattedDates);
                if ((eventsNames.length || !this.boards[this.activeBoardIndex].isFirstTimeLoaded)) {

                    if (isFeaturesAdded || isPeriodChanged || forceUpdate) {
                        this.stopPreviousBoardRequests();
                        this.updateDates();
                        this.setHeightsForFeaturesLoadings();

                        this.currentBoard.savedData.features = Object.freeze(featuresNames);
                        this.currentBoard.savedData.events = Object.freeze(eventsNames);
                        this.currentBoard.savedData.period = Object.freeze(_.cloneDeep(this.currentBoard.datePeriod));
                        this.getSavedDataFeatureSettings();
                        this.additionalFilters = this.mapFilters();
                        this.boards[this.activeBoardIndex].allEvents = _.cloneDeep(this.currentBoard.events);
                        this.boards[this.activeBoardIndex].allFormulas = _.cloneDeep(this.currentBoard.formulas);
                        this.$set(this.boards[this.activeBoardIndex], 'allEventsAndAllFormulas',
                            [...this.boards[this.activeBoardIndex].allEvents, ...this.boards[this.activeBoardIndex].allFormulas]);
                        this.boards[this.activeBoardIndex].deletedEventsAndFormulasIndexes = [];
                        delete this.currentBoard.tempData.predictionCharts;
                        this.boards[this.activeBoardIndex].isFirstTimeLoaded = true;

                        if (isUpdateCache) {
                            this.updateStateForBoards('updateDashboardData', true, true);
                        }
                        this.updateColumnsColorStyles();
                        this.updateHiddenColumnsStyles([]);

                        this.showFeaturesLoadings();
                        this.getArppus(this.activeBoardIndex, this.additionalFilters);
                        this.getFeatures(this.activeBoardIndex, this.additionalFilters);
                        this.getSubscriptions(this.activeBoardIndex, this.additionalFilters);
                        this.getPredictions(this.activeBoardIndex, this.additionalFilters);

                    }
                } else {
                    this.currentBoard.tempData.isDashboardLoaded = true;
                    let errorMessage = '';
                    if (!eventsNames.length) {
                        errorMessage = 'Events should have at least one element';
                    }
                    this.$toastr.longError(
                        errorMessage,
                    );
                }
            },
            openSubscriptionPopup(predictType) {
                this.getPredictions(this.activeBoardIndex, this.additionalFilters, true, predictType);
            },
            addColumnWidthForNewFormula(updateFeaturesWidthNames) {
                this.$nextTick(() => {
                    this.$refs.featureBlock.$refs.vfeatureblock.forEach((feature) => {
                        if (updateFeaturesWidthNames) {
                            if (updateFeaturesWidthNames.includes(feature.shortFeatureName)) {
                                feature.addColumnWidthForNewFormula();
                            }
                        } else {
                            feature.addColumnWidthForNewFormula();
                        }
                    });
                });
            },
            deleteColumnWidthForNewFormula(updateFeaturesWidthNames) {
                this.$nextTick(() => {
                    this.$refs.featureBlock.$refs.vfeatureblock.forEach((feature) => {
                        if (updateFeaturesWidthNames) {
                            if (updateFeaturesWidthNames.includes(feature.shortFeatureName)) {
                                feature.deleteColumnWidthForNewFormula();
                            }
                        } else {
                            feature.deleteColumnWidthForNewFormula();
                        }
                    });
                });
            },
            updateColumnWidthForFormula(rowColumnIndex) {
                this.$nextTick(() => {
                    this.$refs.featureBlock.$refs.vfeatureblock.forEach((feature) =>
                        feature.updateColumnWidthForFormula(rowColumnIndex));
                });
            },
            applyFeatureFilter(featureArrayIndex, selectedRowsNames, filterType) {
                const filters = Object.freeze(selectedRowsNames);
                let featureName;
                if (featureArrayIndex >= 0) {
                    const feature = this.currentBoard.features[featureArrayIndex];
                    featureName = feature.name;

                } else {
                    featureName = 'bundle_id';
                }
                const boardFilters = _.clone(this.boards[this.activeBoardIndex].filters);
                boardFilters.push({
                    name: featureName,
                    changes: filters.length,
                    filters,
                    type: filterType,
                });
                this.boards[this.activeBoardIndex].filters = boardFilters;
                this.updateDashboardData('applyFeatureFilter', true);
            },
            applyFilterSummaryTable(date) {
                let newDatePeriod = {
                    start: '',
                    end: '',
                };
                if (date.length === 1) {
                    switch (this.currentBoard.precision) {
                        case 'year':
                            newDatePeriod = {
                                start: this.$moment(date, 'YYYY'),
                                end: this.$moment(date, 'YYYY').add(1, 'year').add(-1, 'days'),
                            };
                            break;
                        case 'month':
                            newDatePeriod = {
                                start: this.$moment(date, 'MMM ,YYYY'),
                                end: this.$moment(date, 'MMM ,YYYY').add(1, 'month').add(-1, 'days'),
                            };
                            break;
                        case 'quarter':
                            newDatePeriod = {
                                start: this.$moment(date, '[Q]Q YYYY').startOf('quarter'),
                                end: this.$moment(date, '[Q]Q YYYY').endOf('quarter'),
                            };
                            break;
                        case 'week':
                            newDatePeriod = {
                                start: this.$moment(date, 'MMM DD,YYYY'),
                                end: this.$moment(date, 'MMM DD,YYYY').add(6, 'days'),
                            };
                            break;
                        case 'day':
                            newDatePeriod = {
                                start: this.$moment(date, 'MMM DD,YYYY'),
                                end: this.$moment(date, 'MMM DD,YYYY'),
                            };
                            break;
                        case 'hour':
                            newDatePeriod = {
                                start: this.$moment(date, 'HH:MMM DD,YYYY'),
                                end: this.$moment(date, 'HH:MMM DD,YYYY'),
                            };
                            break;
                        default:
                            break;
                    }
                } else {
                    newDatePeriod = {
                        start: this.$moment(date[0], 'MMM DD,YYYY'),
                        end: this.$moment(date[date.length - 1], 'MMM DD,YYYY'),
                    };
                }
                this.currentBoard.componentsSettings.dateTimeHistory = updateTimeHistory(this.currentBoard.datePeriod, this.currentBoard.componentsSettings.dateTimeHistory);
                if (this.currentBoard.datePeriod.utc) {
                    this.currentBoard.datePeriod = {
                        start: `${this.$moment(newDatePeriod.start).format('YYYY-MM-DD')}T00:00:00+00:00`,
                        end: `${this.$moment(newDatePeriod.end).format('YYYY-MM-DD')}T23:55:00+00:00`,
                        utc: true,
                    };
                } else {
                    this.currentBoard.datePeriod = {
                        start: this.$moment(newDatePeriod.start).format(),
                        end: this.$moment(newDatePeriod.end.set({
                            hour: 23,
                            minute: 55,
                            second: 0,
                        })).format(),
                    };
                }
                this.updateDashboardData('applyFilterSummaryTable', true);
            },
            swapHeaderInFeatures() {
                this.$refs.featureBlock.$refs.vfeatureblock.forEach((featureElem) => {
                    const feature = featureElem.feature;
                    if (feature.deletedIndexes.length) {
                        const eventsCount = this.currentBoard.allEvents.length;
                        const currentFutureSettings = this.currentBoard.featuresSettings[feature.name];
                        let deletedIndexes = [];
                        if (currentFutureSettings?.deletedEventsNames) {
                            deletedIndexes = getIndexesByNames(this.currentBoard.allEvents,
                                currentFutureSettings?.deletedEventsNames);
                        }
                        if (currentFutureSettings?.deletedFormulasNames) {
                            const indexes = getIndexesByNames(this.currentBoard.allFormulas,
                                currentFutureSettings?.deletedFormulasNames);
                            const formulasIndexes = indexes.map((index) => {
                                return index + eventsCount;
                            });
                            deletedIndexes = deletedIndexes.concat(formulasIndexes);
                        }
                        feature.deletedIndexes = deletedIndexes;
                        featureElem.updateColumnVisibilityStyles();
                    }
                });
            },
            removeFilter(filter) {
                this.applyFeatureFilter(this.boards[this.activeBoardIndex].features.findIndex((feature) => feature.name
                    === filter.name), []);
            },
            rerenderFeatures() {
                this.$refs.featureBlock.$refs.vfeatureblock.forEach((feature) => feature.filterByName());
            },
            rerenderFeaturesVirtualTable() {
                this.$refs.featureBlock.$refs.vfeatureblock.forEach((feature) => {
                    if (feature.$refs.virtualtable) {
                        feature.$refs.virtualtable.$forceUpdate();
                    }
                });
            },
            rerenderFeaturesAfterSwap(allEventsIndexes) {
                this.$nextTick(() => {
                    this.$refs.featureBlock.$refs.vfeatureblock.forEach((featureElem) => {
                        featureElem.swapColumns(allEventsIndexes);
                    });
                });
            },
            updateDates() {
                if (this.currentBoard.datePeriod.preset) {
                    const offset = this.currentBoard.datePeriod.utc ? -1 * new Date().getTimezoneOffset() : 0;
                    setDataTimePresets(offset);
                    this.presets = [...getDataTimeRangePresets.call(this), getSinceRange(offset)];
                    const currentPreset = this.presets.find((preset) => preset.text ===
                        this.currentBoard.datePeriod.preset);
                    let newDatesArray = [];
                    if (currentPreset.text.toLowerCase() === 'since') {
                        const today =
                            this.$moment(new Date()).utc().endOf('day').subtract(299, 'seconds').format('YYYY-MM-DDTHH:mm:ss');
                        newDatesArray = [this.currentBoard.datePeriod.start, today];
                    } else {
                        newDatesArray = currentPreset.dates;
                    }

                    const newDates = getObjectFromArray(newDatesArray, this.currentBoard.datePeriod.utc);
                    this.boards[this.activeBoardIndex].datePeriod = Object.assign(this.boards[this.activeBoardIndex].datePeriod, newDates);
                }
            },
            updateFeaturesSettings(settings) {
                const newBoard = _.cloneDeep(this.boards[this.activeBoardIndex]);
                newBoard.featuresSettings = _.cloneDeep(settings);
                this.updateBoardByIndex(newBoard, this.activeBoardIndex);
                this.currentBoard = this.boards[this.activeBoardIndex];
                this.updateStateForBoards('updateFeaturesSettings');
            },
            showTooltip(event, name, data) {
                const tooltipData = getDashboardTooltip(name, data);
                this.$emit('showTooltip', event, tooltipData);
            },
            showFeaturesLoadings(bool = true) {
                this.currentBoard.tempData.isFeaturesUpdating = bool;
                this.currentBoard.tempData.isSummaryTableUpdating = bool;
                this.currentBoard.tempData.isEditingSettingsDisabled = bool;
            },
            async updateStateForBoards(methodName, isUpdateInDb = true, isForceupdate = false) {
                if (this.currentBoard.tempData.isDashboardLoaded || isForceupdate) {
                    if (isUpdateInDb) {
                        const currentUniqueId = this.boards[this.activeBoardIndex].uniqueId;
                        apiBoards.updateBoard(this.boards[this.activeBoardIndex], this.isEditMode).then(async (resolve) => {
                            const boardId = resolve.data.id;
                            const boardIndex = this.boards.findIndex(({uniqueId}) => uniqueId === currentUniqueId);
                            this.boards[boardIndex].id = boardId;
                            if (this.activeBoardIndex === boardIndex) {
                                setUrlParam.call(this, 'board_id', boardId);
                            }
                        });
                    }
                }
            },
            updateActiveBoardIndexAfterSwap() {
                this.activeBoardIndex = this.boards.findIndex((board) => board.id === this.currentBoard.id);
            },
            mapFilters() {
                const hiddenFilters = this.currentBoard.currentSource.filter;
                const featureFiltersObject = {
                    equal: {},
                };
                this.currentBoard.filters.forEach((filterObj) => {
                    const type = filterObj.type || 'equal';
                    if (!featureFiltersObject[type]) {
                        featureFiltersObject[type] = {};
                    }
                    featureFiltersObject[type][filterObj.name] = filterObj.filters;
                });
                const bundleIdFilters = {bundle_id: this.currentBoard.projects.map((p) => p.bundle_id)};
                const equal = Object.assign({}, bundleIdFilters, featureFiltersObject.equal);
                const mergedFiltersNames = [];

                const requestFilterObject = {
                    equal: '',
                };

                Object.entries(equal).forEach(([filterName, filters]) => {
                    if (hiddenFilters?.equal && hiddenFilters.equal[filterName]) {
                        mergedFiltersNames.push(filterName);
                        requestFilterObject.equal +=
                            `&equal:${filterName}=${filters.map((v) => encodeURIComponent(v)).join(',')}`;
                    } else {
                        requestFilterObject.equal += `&equal:${filterName}=${filters.map((v) => encodeURIComponent(v)).join(',')}`;
                    }
                });

                const filtersWitoutEqual = _.cloneDeep(featureFiltersObject);
                delete filtersWitoutEqual.equal;

                function mapFilterHelper(filtersArray) {
                    Object.entries(filtersArray).forEach(([filterName, filters]) => {
                        Object.entries(filters).forEach(([filterPropertyName, filterProperties]) => {
                            if (!mergedFiltersNames.includes(filterPropertyName)) {
                                requestFilterObject[filterName] = requestFilterObject[filterName] || '';
                                requestFilterObject[filterName] += `&${filterName}:${filterPropertyName}=${filterProperties}`;
                            }
                        });
                    });
                }

                mapFilterHelper(hiddenFilters);

                if (Object.keys(filtersWitoutEqual).length) {
                    mapFilterHelper(filtersWitoutEqual);
                }

                let requestFilterString = '';
                Object.values(requestFilterObject).forEach((property) => {
                    requestFilterString += property;
                });
                return requestFilterString.trim();
            },
            setHeightsForFeaturesLoadings() {
                const newSettings = _.cloneDeep(this.boards[this.activeBoardIndex].featuresSettings);
                const maxFeatureLoading = '438';
                this.currentBoard.featuresData.forEach((feature) => {
                    const blockName = feature.name.split(' ')[0];
                    const element = document.querySelector(`.VFeatureBlock-${blockName}`);
                    if (!newSettings[feature.name]) {
                        newSettings[feature.name] = {};
                    }
                    if (element) {
                        const height = element.offsetHeight;
                        newSettings[feature.name].featureLoadingHeight = `${height}px`;
                    } else {
                        newSettings[feature.name].featureLoadingHeight = `${maxFeatureLoading}px`;
                    }

                });
                this.boards[this.activeBoardIndex].featuresSettings = newSettings;
            },
            getSubscriptions(boardIndexForRequest = this.activeBoardIndex, additionalFilters) {
                const boardWithSavedBoardId = this.boards[boardIndexForRequest];
                const sendObj = {
                    filter: {
                        dates: '',
                        additional: additionalFilters,
                    },
                };
                if (boardWithSavedBoardId.cohort) {
                    sendObj.filter.dates = `&start=${encodeURIComponent(boardWithSavedBoardId.datePeriod.start)}&end=${encodeURIComponent(boardWithSavedBoardId.datePeriod.end)}`.trim();
                }
                this.currentBoard.tempData.cancelTokenSources.subscriptions = apiHelpers.getCancelTokenSource();
                const body = {cancelToken: this.currentBoard.tempData.cancelTokenSources.subscriptions.token};
                boardWithSavedBoardId.tempData.areSubscriptionsUpdating = true;

                if (!boardWithSavedBoardId.cohort) {
                    const additionalSubscriptions = ['expense', 'revenue'];
                    const allowedSubscriptions = additionalSubscriptions.filter((subscriptionEvent) => getEvents().includes(subscriptionEvent));

                    const getSumByEventFromAdditionalSubscriptions = function (bundleIdFeature, eventName) {
                        if (bundleIdFeature) {
                            const eventIndex = allowedSubscriptions.findIndex((evName) => evName === eventName);
                            if (eventIndex >= 0) {
                                return bundleIdFeature.reduce((acc, row) => {
                                    return acc + +row.counts[eventIndex];
                                }, 0).toFixed(2);
                            }
                        }
                        return null;
                    };

                    addTempBoardData(boardWithSavedBoardId, 'costsSubscription', 0);
                    addTempBoardData(boardWithSavedBoardId, 'revenueSubscription', 0);
                    addTempBoardData(boardWithSavedBoardId, 'areAdditionalSubscriptionsLoading', true);
                    apiFeatures.getSubscriptionEvents(allowedSubscriptions, boardWithSavedBoardId.projects).then((res) => {
                        const bundleIdFeature = res.data.features[0];
                        addTempBoardData(boardWithSavedBoardId, 'costsSubscription', +getSumByEventFromAdditionalSubscriptions(bundleIdFeature, 'expense'));
                        addTempBoardData(boardWithSavedBoardId, 'revenueSubscription', +getSumByEventFromAdditionalSubscriptions(bundleIdFeature, 'revenue'));
                    }).finally(() => {
                        addTempBoardData(boardWithSavedBoardId, 'areAdditionalSubscriptionsLoading', false);
                    });
                }

                apiEvents.getSubscriptionsData(sendObj, body).then((response) => {
                    window.savedRequests.dashboard.subscriptions = response.data.features;
                    this.currentBoard.tempData.cancelTokenSources.subscriptions = null;
                    boardWithSavedBoardId.subscriptions = response.data;
                }).catch((error) => {
                    if (error.response) {
                        this.$toastr.longError(
                            `Subscriptions request error : ${error.response.data.error}`,
                        );
                        this.$nextTick(() => {
                            boardWithSavedBoardId.tempData.isFeaturesUpdating = false;
                            boardWithSavedBoardId.tempData.isEditingSettingsDisabled = false;
                        });
                    }
                }).finally(() => {
                    boardWithSavedBoardId.tempData.areSubscriptionsUpdating = false;
                });
            },
            getPredictions(boardIndexForRequest = this.activeBoardIndex, additionalFilters, charts = false, predictType) {
                if (getUrlParam('predict') && getUrlParam('predict') === 'true') {
                    const boardWithSavedBoardId = this.boards[boardIndexForRequest];
                    const sendObj = {
                        filter: {
                            dates: `&start=${encodeURIComponent(boardWithSavedBoardId.datePeriod.start)}&end=${encodeURIComponent(boardWithSavedBoardId.datePeriod.end)}`.trim(),
                            additional: additionalFilters,
                        },
                        cohort: boardWithSavedBoardId.cohort,
                        sandbox: boardWithSavedBoardId.sandbox,
                        precision: boardWithSavedBoardId.precision,
                        charts,
                    };
                    if (predictType) {
                        sendObj.ltv = predictType;
                    }
                    if (!boardWithSavedBoardId.predictions || !charts) {
                        this.$set(boardWithSavedBoardId, 'predictions', null);
                    }
                    this.currentBoard.tempData.cancelTokenSources.predictions = apiHelpers.getCancelTokenSource();
                    const body = {cancelToken: this.currentBoard.tempData.cancelTokenSources.predictions.token};
                    boardWithSavedBoardId.tempData.arePredictionsUpdating = true;
                    apiEvents.getPredictions(sendObj, body).then((response) => {
                        window.savedRequests.dashboard.predictions = response.data.features;
                        this.currentBoard.tempData.cancelTokenSources.predictions = null;
                        boardWithSavedBoardId.tempData.arePredictionsUpdating = false;
                        this.$set(boardWithSavedBoardId, 'predictions', {...response.data, isChartsOn: charts});
                    }).catch((error) => {
                        if (error.response) {
                            this.$toastr.longError(
                                `Prediction request error : ${error.response.data.error}`,
                            );
                            this.$nextTick(() => {
                                boardWithSavedBoardId.tempData.arePredictionsUpdating = false;
                                boardWithSavedBoardId.tempData.isEditingSettingsDisabled = false;
                            });
                        }
                    }).finally(() => {
                        boardWithSavedBoardId.tempData.arePredictionsUpdating = false;
                    });
                }
            },
            getHistoryActivations(boardIndexForRequest = this.activeBoardIndex, additionalFilters) {
                const boardWithSavedBoardId = this.boards[boardIndexForRequest];
                const savedBoard = _.cloneDeep(this.boards[boardIndexForRequest]);
                boardWithSavedBoardId.tempData.areHistoryActivationsUpdating = true;
                boardWithSavedBoardId.tempData.isSummaryTableUpdating = true;
                const sendObj = {
                    filter: {
                        date: {
                            end: boardWithSavedBoardId.datePeriod.end,
                            start: boardWithSavedBoardId.datePeriod.start,
                            cohort: boardWithSavedBoardId.cohort,
                        },
                        additional: additionalFilters,
                    },
                    events: boardWithSavedBoardId.events.map((e) => e.name),
                    cohort: boardWithSavedBoardId.cohort,
                    sandbox: boardWithSavedBoardId.sandbox,
                    precision: boardWithSavedBoardId.precision,
                };
                this.currentBoard.tempData.cancelTokenSources.historyActivations = apiHelpers.getCancelTokenSource();
                const body = {cancelToken: this.currentBoard.tempData.cancelTokenSources.historyActivations.token};
                apiEvents.getHistoryActivations(sendObj, body).then((response) => {
                    if (isTestBoardsMode()) {
                        boardWithSavedBoardId.historyActivations = Object.freeze(getSavedDashboardData('historyActivations'));
                    } else {
                        boardWithSavedBoardId.historyActivations = Object.freeze(response.data);
                    }

                    window.savedRequests.dashboard.historyActivations = response.data;
                    this.currentBoard.tempData.cancelTokenSources.historyActivations = null;
                    this.getEvents(savedBoard,boardIndexForRequest, additionalFilters);

                }).catch((error) => {
                    if (error.response) {
                        this.$toastr.longError(
                            `Prediction request error : ${error.response.data.error}`,
                        );
                        this.$nextTick(() => {
                            boardWithSavedBoardId.tempData.isEditingSettingsDisabled = false;
                        });
                    }
                }).finally(() => {
                    boardWithSavedBoardId.tempData.areHistoryActivationsUpdating = false;
                });
            },
            getArppus(boardIndexForRequest = this.activeBoardIndex, additionalFilters) {
                const boardWithSavedBoardId = this.boards[boardIndexForRequest];
                const featuresWithBundleId = Object.freeze([getDefaultFeatureWithDataByName('bundle_id')].concat(boardWithSavedBoardId.features));
                const sendObj = {
                    events: boardWithSavedBoardId.events.map((e) => e.name),
                    features: featuresWithBundleId.map((e) => e.name),
                    filter: {
                        date: {
                            end: boardWithSavedBoardId.datePeriod.end,
                            start: boardWithSavedBoardId.datePeriod.start,
                            cohort: boardWithSavedBoardId.cohort,
                        },
                        additional: additionalFilters,
                    },
                    sandbox: boardWithSavedBoardId.sandbox,
                };

                this.currentBoard.tempData.cancelTokenSources.arrpus = apiHelpers.getCancelTokenSource();
                const body = {cancelToken: this.currentBoard.tempData.cancelTokenSources.arrpus.token};
                apiFeatures.getArppus(sendObj, body).then((response) => {
                    boardWithSavedBoardId.arrpus = Object.freeze(response.data);
                    window.savedRequests.dashboard.arrpus = response.data;
                    this.currentBoard.tempData.cancelTokenSources.arrpus = null;
                    let data = {};
                    const oldData = _.cloneDeep(response.data);
                    for (let key in oldData) {
                        if (typeof oldData[key] === 'number') {
                            data[key] = oldData[key].toString();
                        }
                    }
                    this.currentBoard.tempData.arrpusDefault = data;

                }).catch((error) => {
                    if (error.response) {
                        this.$toastr.longError(
                            `Prediction request error : ${error.response.data.error}`,
                        );
                        this.$nextTick(() => {
                            boardWithSavedBoardId.tempData.isEditingSettingsDisabled = false;
                        });
                    }
                });
            },
            getFeatures(boardIndexForRequest = this.activeBoardIndex, additionalFilters) {
                this.geoRows= [];
                const boardWithSavedBoardId = this.boards[boardIndexForRequest];
                const savedBoard = _.cloneDeep(this.boards[boardIndexForRequest]);
                const featuresWithBundleId = Object.freeze([getDefaultFeatureWithDataByName('bundle_id')].concat(boardWithSavedBoardId.features));
                const sendObj = {
                    events: boardWithSavedBoardId.events.map((e) => e.name),
                    features: featuresWithBundleId.map((e) => e.name),
                    filter: {
                        date: {
                            end: boardWithSavedBoardId.datePeriod.end,
                            start: boardWithSavedBoardId.datePeriod.start,
                            cohort: boardWithSavedBoardId.cohort,
                        },
                        additional: additionalFilters,
                    },
                    sandbox: boardWithSavedBoardId.sandbox,
                };

                this.currentBoard.tempData.cancelTokenSources.slice = apiHelpers.getCancelTokenSource();
                const body = {cancelToken: this.currentBoard.tempData.cancelTokenSources.slice.token};
                apiFeatures.getFeaturesData(sendObj, body).then((response) => {

                    document.documentElement.style.cssText += "width: fit-content;";
                    window.savedRequests.dashboard.features = response.data.features;
                    this.currentBoard.tempData.cancelTokenSources.slice = null;
                    if (isTestBoardsMode()) {
                        boardWithSavedBoardId.featuresFromResponse = Object.freeze(getSavedDashboardData('features'));
                    } else {
                        boardWithSavedBoardId.featuresFromResponse = Object.freeze(response.data.features);
                    }

                    const domain = window.location.origin;
                    console.time('Feature mapping');
                    mapFeatureData.call(this, domain, boardWithSavedBoardId.featuresFromResponse,
                        featuresWithBundleId, boardWithSavedBoardId.events,
                        boardWithSavedBoardId.formulas, boardWithSavedBoardId.featuresOrder,
                        boardWithSavedBoardId.featuresSettings,
                        boardWithSavedBoardId.savedData.sessionFeaturesSettings,
                        boardWithSavedBoardId.additionalColumnsByFeatureName, this.currentBoard.arppuCoef).then(features                        => {
                        console.timeEnd('Feature mapping');
                        const featuresWithFrozenRows = features.map((feature) => {
                            feature.rows = Object.freeze(feature.rows);
                            return feature;
                        });
                        boardWithSavedBoardId.tempData.isFeaturesUpdating = false;
                        boardWithSavedBoardId.featuresData = featuresWithFrozenRows;
                        if (boardIndexForRequest === this.activeBoardIndex) {
                            this.normalizeView();
                        }
                        this.getEvents(savedBoard, boardIndexForRequest, additionalFilters)
                    })
                        .catch(error => {
                            this.$toastr.longError(
                                `Slice  worker error : ${error.response.data.message}`,
                            );
                            boardWithSavedBoardId.tempData.isEditingSettingsDisabled = false;
                        });
                }).catch((error) => {
                    if (error.response) {
                        this.$toastr.longError(
                            `Slice request error : ${error.response.data.error}`,
                        );
                        this.$nextTick(() => {
                            boardWithSavedBoardId.tempData.isFeaturesUpdating = false;
                            boardWithSavedBoardId.tempData.isEditingSettingsDisabled = false;
                        });
                    }
                });
            },
            getEvents(saveBoard, boardIndexForRequest = this.activeBoardIndex, additionalFilters, isUpdateSummary = false, isHistoryUpdating= true) {
                this.geoRows.forEach((geoRow)=>{
                  this.addGeoData(geoRow);
                })
                const boardWithSavedBoardId = this.boards[boardIndexForRequest];
                boardWithSavedBoardId.tempData.isEditingSettingsDisabled = true;
                if (isUpdateSummary) {
                  boardWithSavedBoardId.tempData.isSummaryTableUpdating = true;
                  if (isHistoryUpdating) {
                    boardWithSavedBoardId.tempData.isHistoryUpdating = true;
                  }
                }
                const eventsNames = _.cloneDeep(saveBoard.events).map((e) => e.name);
                const sendObj = {
                    events: eventsNames,
                    filter: {
                        date: {
                            end: boardWithSavedBoardId.datePeriod.end,
                            start: boardWithSavedBoardId.datePeriod.start,
                            cohort: boardWithSavedBoardId.cohort,
                        },
                        additional: additionalFilters,
                    },
                    sandbox: boardWithSavedBoardId.sandbox,
                    precision: boardWithSavedBoardId.precision,
                    groupByCohort: boardWithSavedBoardId.groupByCohort && boardWithSavedBoardId.cohort,
                };

                this.currentBoard.tempData.cancelTokenSources.history = apiHelpers.getCancelTokenSource();
                const body = {cancelToken: this.currentBoard.tempData.cancelTokenSources.history.token};

                apiEvents.getEventsData(sendObj, body).then((response) => {
                    window.savedRequests.dashboard.events = response.data.events;
                    window.savedRequests.dashboard.notes = response.data.notes;
                    let respEvents = response.data.events;
                    if (isTestBoardsMode()) {
                        respEvents = Object.freeze(getSavedDashboardData('events'));
                    }
                    this.currentBoard.tempData.cancelTokenSources.history = null;
                    boardWithSavedBoardId.tempData.isEditingSettingsDisabled = false;
                    const summaryBoardIndex = boardWithSavedBoardId.featuresData.findIndex((featureData) =>
                        featureData.name === 'Summary');
                    console.time('Summary mapping');
                    const notesFromRequest = response.data.notes ? response.data.notes : [];
                    boardWithSavedBoardId.summaryNotes = notesFromRequest;
                    const summaryBoard = mapSummaryTable(respEvents,
                        _.cloneDeep(saveBoard.events),
                        boardWithSavedBoardId.formulas, boardWithSavedBoardId.precision,
                        boardWithSavedBoardId.featuresSettings,
                        boardWithSavedBoardId.savedData.sessionFeaturesSettings,
                        boardWithSavedBoardId.additionalColumnsByFeatureName,boardWithSavedBoardId.arppuCoef);
                    console.timeEnd('Summary mapping');
                    boardWithSavedBoardId.tempData.isSummaryTableUpdating = false;
                    boardWithSavedBoardId.tempData.isHistoryUpdating = false;
                    boardWithSavedBoardId.featuresData.splice(summaryBoardIndex, 1, summaryBoard);
                    boardWithSavedBoardId.tempData.isDashboardLoaded = true;
                }).catch((error) => {
                    if (error.response) {
                        this.$toastr.longError(
                            `History request error : ${error.response.data.error}`,
                        );
                        boardWithSavedBoardId.tempData.isEditingSettingsDisabled = false;
                    }
                }).finally(() => {
                    boardWithSavedBoardId.tempData.isHistoryUpdating = false;
                });
            },
          async getGeoHistory(saveBoard, boardIndexForRequest = this.activeBoardIndex, additionalFilters, geoName) {
            const boardWithSavedBoardId = this.boards[boardIndexForRequest];
            const cleanedQueryString = additionalFilters.replace(/&equal:geo=[^&]*/, '');
            const sendObj = {
              events: _.cloneDeep(saveBoard.events).map((e) => e.name),
              filter: {
                date: {
                  end: boardWithSavedBoardId.datePeriod.end,
                  start: boardWithSavedBoardId.datePeriod.start,
                  cohort: boardWithSavedBoardId.cohort,
                },
                additional: `${cleanedQueryString}&equal:geo=${geoName}`,
              },
              sandbox: boardWithSavedBoardId.sandbox,
              precision: boardWithSavedBoardId.precision,
              groupByCohort: boardWithSavedBoardId.groupByCohort && boardWithSavedBoardId.cohort,
            };

            this.currentBoard.tempData.cancelTokenSources.historyGeo = apiHelpers.getCancelTokenSource();
            const body = { cancelToken: this.currentBoard.tempData.cancelTokenSources.historyGeo.token };

            try {
              const response = await apiEvents.getEventsData(sendObj, body);
              let respEvents = response.data.events;
              this.currentBoard.tempData.cancelTokenSources.historyGeo = null;
              console.time('Summary mapping');
              const summaryBoard = mapSummaryTable(respEvents,
                  _.cloneDeep(saveBoard.events),
                  boardWithSavedBoardId.formulas, boardWithSavedBoardId.precision,
                  boardWithSavedBoardId.featuresSettings,
                  boardWithSavedBoardId.savedData.sessionFeaturesSettings,
                  boardWithSavedBoardId.additionalColumnsByFeatureName, boardWithSavedBoardId.arppuCoef);
              console.timeEnd('Summary mapping');
              const rows = summaryBoard.rows;
              return rows;
            } catch (error) {
              if (error.response) {
                this.$toastr.longError(
                    `History geo request error : ${error.response.data.error}`,
                );
              }
              return null;
            }
          },
          importBoard() {
                const board = _.cloneDeep(this.boards[0]);
                this.addBoard((newBoardId) => {
                    board.id = newBoardId;
                    this.reloadWithUserBoards(board);
                });
            },
            reloadWithUserBoards(oldBoard) {
                setUrlParam.call(this, 'board_id', oldBoard.id);
                initPreload(true).then(() => {
                    this.$emit('updateEditMode');
                    const boards = _.clone(getBoards());
                    const boardsIndex = boards.findIndex((board) => board.id === oldBoard.id);
                    boards[boardsIndex] = _.cloneDeep(oldBoard);
                    this.boards = Object.freeze(boards);
                    this.activeBoardIndex = boardsIndex;
                });
            },
            changeActiveTab(newActiveTabIndex, oldActiveTabIndex) {
                this.scrollPositions[this.currentBoard.id] = window.pageYOffset;
                this.saveStateForBoard(oldActiveTabIndex);
                this.activeBoardIndex = newActiveTabIndex;
                this.$emit('removeToastr');
            },
            updateBoardByIndex(newBoard, index) {
                const boards = _.clone(this.boards);
                boards[index] = _.cloneDeep(newBoard);
                this.boards = Object.freeze(boards);
            },
            clearFeatureStyles() {
                if (this.$refs.featureBlock && this.$refs.featureBlock.$refs.vfeatureblock) {
                    this.$refs.featureBlock.$refs.vfeatureblock.forEach((featureElem) => {
                        if (featureElem) {
                            featureElem.deleteColumnsStyles();
                        }
                    });
                }
            },
            stopPreviousBoardRequests() {
                if (this.currentBoard.tempData.cancelTokenSources.predictions) {
                    this.currentBoard.tempData.cancelTokenSources.predictions.cancel();
                    this.currentBoard.tempData.cancelTokenSources.predictions = null;
                }
                if (this.currentBoard.tempData.cancelTokenSources.slice) {
                    this.currentBoard.tempData.cancelTokenSources.slice.cancel();
                    this.currentBoard.tempData.cancelTokenSources.slice = null;
                }
                if (this.currentBoard.tempData.cancelTokenSources.history) {
                    this.currentBoard.tempData.cancelTokenSources.history.cancel();
                    this.currentBoard.tempData.cancelTokenSources.history = null;
                }
                if (this.currentBoard.tempData.cancelTokenSources.subscriptions) {
                    this.currentBoard.tempData.cancelTokenSources.subscriptions.cancel();
                    this.currentBoard.tempData.cancelTokenSources.subscriptions = null;
                }

                if (this.currentBoard.tempData.cancelTokenSources.historyActivations) {
                    this.currentBoard.tempData.cancelTokenSources.historyActivations.cancel();
                    this.currentBoard.tempData.cancelTokenSources.historyActivations = null;
                }
                if (this.currentBoard.isFirstTimeLoaded) {
                    this.showFeaturesLoadings(false);
                }
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
  .dashboard {
    &__import-board {
      width: 50px;
      height: 41px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      &-icon {
        height: 20px;
        width: 23px;
        pointer-events: none;
        background-position: 0 0;
        background-size: contain;
        background-repeat: no-repeat;
        background-image: url('data:image/svg+xml;base64,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');

      }
    }

    &-settings-line {
      position: sticky;
      top: 0;
      z-index: 99;
      background: #FFFFFF;

      &_sticked {
        @include light-shadow;
      }
    }

    &__name {
      color: #000F48;
      font-size: 24px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 30px;
      text-align: left;
      margin-bottom: 15px;
      margin-top: 40px;
    }

    ::v-deep &-attributes {
      .VFilter-dropdown {
        display: flex;
        flex-wrap: wrap;
        width: 430px;
        right: 0;

        &-row {
          flex: 0 47%;
        }
      }
    }

    ::v-deep {
      .Vheader {
        &-left {
          max-width: calc(100% - 70px);
        }

        //&-right {
        //    width: 110px;
        //    justify-content: left;
        //}
      }
    }
  }


  #preloadedImages {
    width: 0px;
    height: 0px;
    display: none;
  }


</style>
